import { LandingTranslationType } from "../../features/landing.types";

export const landing: LandingTranslationType = {
  landing: {
    hero: {
      title: "创作故事",
      subtitle: "激发您的创造力",
      description: "使用AI辅助的互动讲故事平台，创建引人入胜的故事和角色", // Added missing translation
      startStory: "开始创作",
      signIn: "登录"
    },
    features: {
      title: "释放创造力",
      aiPowered: {
        title: "AI驱动的故事",
        description: "使用我们先进的AI叙事引擎创作独特的故事"
      },
      interactiveChoices: {
        title: "互动选择",
        description: "通过有意义的决定和自定义行动塑造您的故事"
      },
      creativeFreedom: {
        title: "创作自由",
        description: "通过无限的创作可能性书写您的故事"
      }
    },
    preview: {
      title: "故事预览",
      storyText: "古老的门发出吱呀声打开了，显露出一个被幽蓝色光芒笼罩的房间...",
      whatToDo: "你会怎么做？",
      choice1: "谨慎接近，检查房间是否有陷阱",
      choice2: "使用魔法检测危险的咒语",
      choice3: "勇敢地抓住机会 - 命运眷顾勇者！"
    },
    storyPreview: {
      header: "体验沉浸式讲故事",
      description: "在{{appName}}的动态交互环境中创建、探索和塑造故事",
      genres: "类型",
      themes: "主题",
      environment: "环境",
      writeResponse: "写下您自己的回应...",
      previousStory: "上一个故事",
      nextStory: "下一个故事",
      goToStory: "转到故事 {{number}}"
    },
    callToAction: {
      title: "准备好开始您的旅程了吗？",
      subtitle: "加入数千名使用AI创作独特冒险的故事创作者",
      button: "现在开始写作"
    },
    creativeSuite: {
      title: "创作套件",
      description: "强大的工具，释放您的讲故事潜能，让您的想象力栩栩如生",
      categories: {
        stories: "故事",
        characters: "角色",
        premium: "高级版"
      },
      premiumFeature: "高级功能",
      basicFeature: "基础计划可用",
      freeFeature: "对所有人免费",
      getStarted: "开始使用",
      noCreditCard: "无需信用卡即可开始您的创意之旅",
      tools: {
        aiWriting: {
          title: "AI驱动写作",
          description: "使用先进的AI创作选择自己的冒险故事。通过建议的回应推进故事或撰写自己的回应。"
        },
        genresThemes: {
          title: "丰富的类型、主题和环境",
          description: "作为免费用户，可访问有限的类型集合，或通过基础版解锁所有类型和主题。"
        },
        sequels: {
          title: "故事续集和系列",
          description: "通过续集继续您最好的故事，构建引人入胜的故事系列。"
        },
        characterBuilder: {
          title: "角色构建器",
          description: "设计复杂的角色，包括详细的个性、动机和背景故事。"
        },
        aiPortraits: {
          title: "AI角色肖像",
          description: "使用我们的AI肖像生成器为您的角色创建独特的视觉表现。"
        },
        characterExtract: {
          title: "角色提取",
          description: "自动从您的故事中提取角色，构建您的角色库。"
        },
        sharing: {
          title: "故事分享和发布",
          description: "分享您的故事并公开发布，让他人欣赏和喜爱。"
        },
        unlimitedStorage: {
          title: "增加故事限制",
          description: "免费版每天最多创建5个故事，基础版25个，高级版无限制。"
        },
        statsBadges: {
          title: "统计和徽章",
          description: "追踪您的写作统计数据，为您的讲故事成就赢取徽章。"
        }
      }
    },
    exampleStories: {
      dragonsRiddle: {
        title: "龙的谜题",
        excerpt: "这只古老的龙提出了一个几个世纪以来一直未解的谜题。\"回答正确，\"它咆哮道，\"我将允许你穿越这座山。\"巨大生物的鳞片在昏暗的洞穴光线下闪烁如黑曜石。我站在那里，指尖颤抖地抵着冰冷的石头，我的伙伴在我身后冻结不动。龙的琥珀色眼睛盯着我的。\"但如果失败，\"这野兽继续道，\"你将加入那些先来者的白骨。\"它指向我试图不去注意的散落残骸。龙喜欢文字游戏和隐藏意义。我们任务的命运取决于我破译这生物谜题的能力。",
        suggestion1: "\"答案是'时间'——它吞噬一切，却从不被消耗，\"我宣布道，比我感觉到的更加自信。",
        suggestion2: "我恭敬地向这古老的野兽鞠躬。\"伟大的存在，我能否请教关于您谜题的澄清问题？\"",
        suggestion3: "我瞥了一眼同伴们恐惧的脸，然后转向龙。\"也许我们可以协商另一条通路？\""
      },
      echoesFromTomorrow: {
        title: "来自明日的回声",
        excerpt: "米兰达·陈博士盯着屏幕上的消息。它昨天到达，但时间戳显示它是明天发送的。她再次阅读：\"欧米茄协议启动。不要继续测试序列。灾难性时间崩溃迫在眉睫。\"米兰达检查了她设计的量子通信阵列——它本应减少信号延迟，而非穿透现在与明天之间的帷幕。嵌入消息中的量子签名与他们的加密协议完全匹配，但有一个不可能的异常：它们显示了尚不应存在的衰变模式。当她的终端响起另一条即将到来的消息时，米兰达感到一阵寒意。发件人ID显示了她自己的名字。",
        suggestion1: "米兰达迅速打字：\"这里是陈博士。请确认您的身份并解释您如何访问我们的安全系统。\"",
        suggestion2: "她启动紧急关机，同时将所有项目数据备份到安全的离线服务器。",
        suggestion3: "她呼叫她的研究伙伴：\"健二，量子阵列发生了一些不可能的事情。\""
      },
      forgottenLibrary: {
        title: "被遗忘的图书馆",
        excerpt: "这图书馆只在雨夜出现，它的门为那些最需要答案的人打开。我寻找它多年，追随着流言和晦涩的引用。现在，当我站在它那不可能的建筑前——内部比外部更大——我犹豫了。巨大的橡木门微微敞开，温暖的光洒在湿漉漉的鹅卵石上。入口大厅高得不可思议，书架延伸到天花板应在的地方之外。空气中弥漫着纸张、墨水和一些更古老的气味——就像时间本身有了味道。我注意到低语声越来越强，来自成千上万的书籍同时说话。然后，一个声音高于其他声音：\"我们一直在等你。\"",
        suggestion1: "\"谁在那里？\"我喊道，我的声音在洞穴般的空间中回荡，同时我扫视着阴暗的过道。",
        suggestion2: "我走近最近的书架，用手指沿着古老的书脊滑动，好奇哪本书在说话。",
        suggestion3: "\"我来寻找关于天体汇聚的信息，\"我向低语的图书馆宣布。"
      }
    }
  }
};
